<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="epi" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<div class="senseline">
<p class="epsl"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>They are not long, the days of wine and roses:</p>
<p class="epsl">Out of a misty dream</p>
<p class="epsl">Our path emerges for a while, then closes</p>
<p class="epsl">Within a dream.</p>
</div>
<p class="ept">—Ernest Dowson, “Vitae summa brevis spem nos vetat incohare longam”</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-scheibel-0006.vue?716800c9